import { heroStyle } from 'modules/ui/services'

export default {
  computed: {
    percaysoHeroStyle() {
      return process.env.VUE_APP_TYPE === 'percayso' ? heroStyle() : {}
    }
  }
}
